'use client';

import React, { type FC } from 'react';
import type { ColorTypeModel } from '../../models';

export type SpinnerColorTypeModel = Extract<
  ColorTypeModel,
  'secondary' | 'gray' | 'white'
>;

const typeThemes: Record<SpinnerColorTypeModel, string> = {
  secondary: 'border-CoolGray-900',
  gray: 'border-CoolGray-400',
  white: 'border-white',
};

interface Props {
  colorType: SpinnerColorTypeModel;
}

const Spinner: FC<Props> = ({ colorType = 'white' }) => {
  return (
    <div
      className={`w-full h-full ${typeThemes[colorType]} rounded-full animate-spin
      border-2 border-solid border-t-transparent`}
    />
  );
};

export default Spinner;
